
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/themekeyword",
      function () {
        return require("private-next-pages/search/themekeyword/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/themekeyword"])
      });
    }
  